import React from 'react';
import { PropTypes } from 'prop-types';
import {
  Icons,
  Button,
  Stack,
  SecurityHelper,
  FlexRow,
  FlexCol,
  ButtonGroup,
} from 'sarsaparilla';

const propTypes = {
  areas: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchCriteria: PropTypes.object,
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  onClear: PropTypes.func
};

const defaultProps = {};

export default class DivisionFilters extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      searchText: props.searchCriteria.searchText,
      areas: Object.assign([], props.searchCriteria.areas)
    };
    this.isMobileApp = SecurityHelper.isMobileApp();
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleAreaChange = this.handleAreaChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onApply = this.onApply.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  onClose() {
    this.props.onClose();
  }

  onApply() {
    this.props.onApply(this.state.searchText, this.state.areas, this.state.motorSize);
  }

  onClear() {
    this.setState({
      searchText: '',
      areas: [],
      motorSize: null
    });
    this.props.onClear();
  }

  handleSearchChange(event) {
    const value = event.target.value;
    this.setState({
      searchText: value
    });
  }

  handleAreaChange(value) {
    const areas = this.state.areas;
    if (areas.indexOf(value) >= 0) {
      areas.splice(areas.indexOf(value), 1);
    }
    else {
      areas.push(value);
    }
    this.setState({ areas });
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.onApply();
    }
  }

  render() {
    const areaList = this.props.areas
    .filter((area) => area)
    .map((area, key) => (
      <label htmlFor={`checkbox-${area}`} key={`area-key-${key}`}>
        <input
          type="checkbox"
          aria-label={area}
          className="rec-input-hide"
          id={`checkbox-${area}`}
          name="checkbox"
          checked={this.state.areas.indexOf(area) >= 0}
          onChange={this.handleAreaChange.bind(this, area)}
          value={area} />
        <span>{area}</span>
      </label>
    ));

    return (
      <Stack>
        {!this.isMobileApp && (
          <div className="rec-filter-flex-wrap">
            <label htmlFor="division-search-input">Search</label>
            <div className="filter-options">
              <input
                type="text"
                id="division-search-input"
                value={this.state.searchText}
                onChange={this.handleSearchChange}
                onKeyPress={this.handleKeyPress}
                placeholder="Search entrance name, Trout Lake, etc..." />
            </div>
          </div>
        )}
        <div className="rec-filter-flex-wrap">
          <legend id="area-filter">Area</legend>
          <div className="rec-check-buttons-wrap" role="group" aria-label="Area">
            {areaList}
          </div>
        </div>
        {!this.isMobileApp && (
          <FlexRow>
            <FlexCol xs={12} md={6} className="mb-2">
              <ButtonGroup align="left">
                <Button
                  appearance="link"
                  iconBeforeElement={<Icons.IconCloseCircle />}
                  onClick={this.onClear}>
                  Clear All Filters
                </Button>
              </ButtonGroup>
            </FlexCol>
            <FlexCol xs={12} md={6}>
              <ButtonGroup align="right">
                <Button
                  appearance="link"
                  onClick={this.onClose}>
                  Close
                </Button>
                <Button
                  onClick={this.onApply}>
                  Show Results
                </Button>
              </ButtonGroup>
            </FlexCol>
          </FlexRow>
        )}
      </Stack>
    );
  }
}

DivisionFilters.propTypes = propTypes;
DivisionFilters.defaultProps = defaultProps;

